/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';

import { InputComponent } from '../form/InputComponent';
import { Button } from '../Button';

import { selectAllContentfulData } from '../../reducers/contentful.reducer';
import { selectAccount, selectUser, setDownloadOk, selectSelectedAccount } from '../../reducers/account.reducer';

import { getRelationsBetweenSurveys } from '../../utils/utils';
import { USER_ROLES } from '../../utils/constants';
import { getOneDoc } from '../docGeneration/docx-utils';
import { getOneExcel } from '../docGeneration/excel-utils';

let GENERATION_MODES = {
  WORD: 'docx',
  EXCEL: 'excel',
  ALL: 'all',
};

export const DashboardGeneration = () => {
  //redux
  const dispatch = useDispatch<any>();
  const contentfulData = useSelector(selectAllContentfulData);
  const account = useSelector(selectAccount);
  const user = useSelector(selectUser);
  const selectedAccount = useSelector(selectSelectedAccount);

  //state
  const [generationMode, setGenerationMode] = useState(GENERATION_MODES.WORD);
  const [targetGeneration, setTargetGeneration] = useState(null);
  const [targetZipContent, setTargetZipContent] = useState([]);
  const [lang, setLang] = useState('FR');

  const getDocxOptions = () => {
    return (
      contentfulData.documents
        .filter(document => selectedAccount?.actionRights?.documents?.some(documentRight => document.id === documentRight.id))
        .filter(document => document.lang === lang)
        .map(document => ({ value: document.id, label: document.name })) || []
    );
  };

  const handleTargetDoc = (name, value) => {
    let newGenerationEntity = {
      ...targetGeneration,
      docId: value,
    };
    if (value === undefined) {
      delete newGenerationEntity.docId;
    }
    setTargetGeneration(newGenerationEntity);
  };

  const handleTargetGeneration = (name, value) => {
    let newGenerationEntity = {
      ...targetGeneration,
      [name]: value,
    };
    setTargetGeneration(newGenerationEntity);
  };

  const handleTargetEntity = (targetName, value) => {
    let { name, id } = JSON.parse(value);
    let newGenerationEntity = {
      ...targetGeneration,
      name: name,
      entityId: id,
    };
    setTargetGeneration(newGenerationEntity);
  };

  const getSurveysByDocId = (docId, entityName) => {
    let surveys;
    let links = getRelationsBetweenSurveys(contentfulData.surveys, contentfulData.documents, selectedAccount.actionRights?.surveys).docToSurveys;
    if (!docId) {
      surveys = _.cloneDeep(contentfulData.surveys).filter(survey => selectedAccount.actionRights?.surveys?.some(userSurvey => userSurvey.id === survey.id));
    } else {
      surveys = _.cloneDeep(contentfulData.surveys).filter(survey => links[docId]?.some(linkedSurvey => linkedSurvey === survey.id));
    }

    if (!entityName) {
      return;
    }

    let versions = surveys.map(survey => {
      let surveyResponsesVersions = getEntityResponseByEntityName(entityName).find(entityResponse => entityResponse.surveyId === survey.id)?.versions;
      let versionsNames = [];
      if (surveyResponsesVersions) {
        surveyResponsesVersions.forEach(surveyResponsesVersion => versionsNames.push(surveyResponsesVersion.versionName));
      }
      return {
        survey: survey,
        versioning: survey.versioning,
        versions: versionsNames,
      };
    });

    return versions;
  };

  const getEntityResponseByEntityName = entityName => {
    return selectedAccount?.entities?.find(entity => entity.name === entityName)?.responses;
  };

  const handleDocxSubmit = async () => {
    let values = getTargetedValues();
    await getOneDoc(values, targetGeneration.docId, targetGeneration.name, selectedAccount._id, lang);
  };

  const getTargetedValues = () => {
    let targetedValues = {};
    let entityResponses = selectedAccount.entities.find(entity => entity.name === targetGeneration.name).responses;
    if (!entityResponses.length) {
      return;
    }
    entityResponses.forEach(surveyResponses => {
      targetedValues = {
        ...targetedValues,
        ...(targetGeneration[surveyResponses.surveyId]
          ? surveyResponses.versions.find(version => version.versionName === targetGeneration[surveyResponses.surveyId])?.versionResponses
          : surveyResponses.versions[0]?.versionResponses),
      };
    });
    return targetedValues;
  };

  const handleExcelSubmit = async () => {
    let values = getTargetedValues();
    await getOneExcel(values, targetGeneration.registryId, targetGeneration.name, targetGeneration.entityId, selectedAccount._id);
  };

  // const getPath = (doc, type) => {
  //   let path = doc.entityName + '/' + doc.documentName + '/';
  //   let parsedVersionName = doc.versionName.replaceAll('/', '_');
  //   if (parsedVersionName !== 'default') {
  //     path += parsedVersionName + '/';
  //   }
  //   path += parsedVersionName + ' - ' + doc.documentName + '.' + type;
  //   return path;
  // };

  /*  const getCustomZip = async () => {
    let zip = new JSZip();
    let variants = getAllResponsesVariantsFromZipContent();
    let excels = variants.filter(variant => variant.document.type === 'excel');
    let word = variants.filter(variant => variant.document.type === 'docx');

    let zipDocxContentBlobs = await getAllDocBlob(word, contentfulData.documents);
    let zipExcelContentBlobs = await getAllExcelBlob(excels, contentfulData.registries);

    zipDocxContentBlobs.forEach(doc => {
      zip.file(getPath(doc, 'docx'), doc.blob);
    });
    zipExcelContentBlobs.forEach(excel => {
      zip.file(getPath(excel, 'xlsx'), excel.blob);
    });
    let content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, `${selectedAccount.companyName}.zip`);
  };

  const getZippedRegistries = async (blobs, values) => {
    let zip = new JSZip();
    blobs.forEach(doc => {
      zip.file(doc.name + '.xlsx', doc.blob);
    });
    let content = await zip.generateAsync({ type: 'blob' });
    let name = values.sign ?? 'dipeeo';
    saveAs(content, name.replaceAll(' ', '_') + '-registries.zip');
  };*/

  const getRegistriesOptions = () => {
    return (
      contentfulData.registries
        .filter(registry => selectedAccount?.actionRights?.registries?.some(registryRights => registry.id === registryRights.id))
        .filter(document => document.lang === lang)
        .map(registry => ({ value: registry.id, label: registry.name })) || []
    );
  };

  const handleTargetRegistry = (name, value) => {
    let newGenerationEntity = {
      ...targetGeneration,
      registryId: value,
    };
    if (value === undefined) {
      delete newGenerationEntity.registryId;
    }
    setTargetGeneration(newGenerationEntity);
  };

  // const handleTargetLang = (name, value) => dispatch(setLang(value));
  const handleTargetLang = (name, value) => setLang(value);

  const getSurveysByRegistryId = (registryId, entityName) => {
    let surveys = _.cloneDeep(contentfulData.surveys).filter(survey => selectedAccount.actionRights?.surveys?.some(userSurvey => userSurvey.id === survey.id));
    if (!entityName) {
      return;
    }

    let versions = surveys.map(survey => {
      let surveyResponsesVersions = getEntityResponseByEntityName(entityName)?.find(
        entityResponse => entityResponse.surveyId === survey.id
      )?.versions;
      let versionsNames = [];
      if (surveyResponsesVersions) {
        surveyResponsesVersions.forEach(surveyResponsesVersion => versionsNames.push(surveyResponsesVersion.versionName));
      }

      return {
        survey: survey,
        versioning: survey.versioning,
        versions: versionsNames,
      };
    });

    return versions.filter(version => version.versioning.enabled);
  };

  const handleChangeGenerationMode = targetMode => {
    setGenerationMode(targetMode);
  };

  const getEntitiesOptions = () =>
    selectedAccount?.entities?.map(entity => ({
      label: entity.name.replaceAll('_', ' '),
      value: JSON.stringify({
        name: entity.name,
        id: entity._id,
      }),
    }));

  const getLangOptions = () => [
    { value: 'FR', label: 'Français' },
    { value: 'EN', label: 'Anglais' },
  ];

  // const getAllResponsesVariantsFromZipContent = () => {
  //   let variantsData = [];
  //   targetZipContent.forEach(entity => {
  //     let entityResponse = getEntityResponseByEntityName(entity.name);
  //     entity.includedDocuments.forEach(includedDocument => {
  //       let dependentSurveys =
  //         includedDocument.type === 'docx'
  //           ? getSurveysByDocId(includedDocument.value, entity.name)
  //           : getSurveysByRegistryId(includedDocument.value, entity.name);

  //       let versionedSurveys = dependentSurveys?.filter(survey => survey.versioning.enabled);
  //       let nonVersionedSurveys = dependentSurveys?.filter(survey => !survey.versioning.enabled);
  //       let responsesAllVariant = [];
  //       let responseVariant = {};

  //       versionedSurveys?.forEach(versionedSurvey => {
  //         nonVersionedSurveys.forEach(survey => {
  //           let surveyResponses = entityResponse.find(entityResponse => entityResponse.surveyId === survey.survey.id)?.versions;
  //           responseVariant = { ...surveyResponses[0].versionResponses };
  //         });

  //         versionedSurvey.versions.forEach(version => {
  //           let surveyResponses = entityResponse.find(entityResponse => entityResponse.surveyId === versionedSurvey.survey.id)?.versions;
  //           let currentVersion = surveyResponses.find(surveyResponses => surveyResponses.versionName === version);

  //           if (versionedSurveys.length > 1) {
  //             versionedSurveys.forEach(subVersionSurvey => {
  //               if (subVersionSurvey.survey.id !== versionedSurvey.survey.id) {
  //                 let surveyResponses = entityResponse.find(entityResponse => entityResponse.surveyId === subVersionSurvey.survey.id)?.versions;
  //                 let currentVersion = surveyResponses.find(responses => {
  //                   return responses.versionName === version;
  //                 });
  //                 responseVariant = { ...responseVariant, ...currentVersion?.versionResponses };
  //               }
  //             });
  //           }

  //           let responseVariantObj = {
  //             versionName: version,
  //             versionData: { ...responseVariant, ...currentVersion?.versionResponses },
  //           };
  //           responsesAllVariant.push(responseVariantObj);
  //         });
  //       });

  //       if (!versionedSurveys?.length) {
  //         nonVersionedSurveys.forEach(survey => {
  //           let surveyResponses = entityResponse.find(entityResponse => entityResponse.surveyId === survey.survey.id)?.versions;
  //           responseVariant = {
  //             versionName: 'default',
  //             versionData: { ...surveyResponses[0].versionResponses },
  //           };
  //           responsesAllVariant.push(responseVariant);
  //         });
  //       }

  //       variantsData.push({
  //         entityName: entity.name,
  //         document: {
  //           name: includedDocument.label,
  //           id: includedDocument.value,
  //           type: includedDocument.type,
  //         },
  //         data: responsesAllVariant,
  //       });
  //     });
  //   });
  //   return variantsData;
  // };

  const toggleZipContent = (document, entity, checked, docType) => {
    let targetZipCopy = _.cloneDeep(targetZipContent);
    let targetEntity = targetZipCopy.find(currentEntity => currentEntity.name === entity.name);

    document = { ...document, type: docType };

    if (!checked) {
      targetEntity.includedDocuments = targetEntity.includedDocuments.filter(currentDocument => currentDocument.value !== document.value);
      setTargetZipContent(targetZipCopy);
      return;
    }

    if (!targetEntity) {
      targetZipCopy.push({
        name: entity.name,
        includedDocuments: [document],
      });
    } else {
      targetEntity.includedDocuments.push(document);
    }

    setTargetZipContent(targetZipCopy);
    return;
  };

  const isCheckedZipContent = (document, entity) => {
    let targetEntity = targetZipContent.find(currentEntity => currentEntity.name === entity.name);
    if (!targetEntity) {
      return false;
    }
    return targetEntity.includedDocuments.some(currentDocument => currentDocument.label === document.label);
  };

  const isGenerationReady = () => {
    return (targetGeneration?.docId || targetGeneration?.registryId) && targetGeneration?.entityId && lang !== undefined;
  };

  useEffect(() => {
    dispatch(setDownloadOk(account?.activity?.remainingDownload > 0 ?? false));
  }, [user]);

  return (
    <DashboardGenerationContainer>
      <TopContainer>
        <TabContainer>
          <Tab current={generationMode === GENERATION_MODES.WORD} onClick={() => handleChangeGenerationMode(GENERATION_MODES.WORD)}>
            WORD
          </Tab>
          {account?.accountType === USER_ROLES.ADMIN && (
            <>
              <Tab current={generationMode === GENERATION_MODES.EXCEL} onClick={() => handleChangeGenerationMode(GENERATION_MODES.EXCEL)}>
                EXCEL
              </Tab>
            </>
          )}
        </TabContainer>
        {/*({selectedAccount.activity.remainingDownload} générations restantes)*/}
      </TopContainer>
      <Content>
        {generationMode === GENERATION_MODES.WORD && (
          <>
            <FixInputContainer>
              <InputContainer>
                <InputComponent
                  name={'word_choice'}
                  type={'select'}
                  label={'Choix du Document'}
                  options={getDocxOptions()}
                  onChange={handleTargetDoc}
                  clearable={true.toString()}
                  value={getDocxOptions().filter(value => {
                    return value.value === targetGeneration?.docId;
                  })}
                  sharable={false}
                />
              </InputContainer>
              <InputContainer>
                <InputComponent
                  key={'entity_choice'}
                  name={'entity_choice'}
                  type={'select'}
                  label={"Choix de l'entreprise"}
                  options={getEntitiesOptions()}
                  onChange={handleTargetEntity}
                  sharable={false}
                />
              </InputContainer>
              <InputContainer>
                <InputComponent
                  key={'lang_choice'}
                  name={'lang_choice'}
                  type={'select'}
                  label={'Choix de la langue'}
                  options={getLangOptions()}
                  onChange={handleTargetLang}
                  sharable={false}
                  value={{ value: 'FR', label: 'Français' }}
                />
              </InputContainer>
            </FixInputContainer>
            <VersionChoiceContainer>
              {targetGeneration?.name &&
                getSurveysByDocId(targetGeneration?.docId, targetGeneration?.name)?.map((link, index) => {
                  return (
                    <React.Fragment key={index}>
                      {link.versioning.enabled && (
                        <VersionItem>
                          <InputComponent
                            key={link.survey.name + index}
                            name={link.survey.id}
                            type={'select'}
                            label={link.survey.name}
                            options={link.versions.map(version => ({
                              label: version.replaceAll('_', ' '),
                              value: version,
                            }))}
                            onChange={handleTargetGeneration}
                            value={targetGeneration[link.survey.id] || ''}
                            sharable={false}
                          />
                        </VersionItem>
                      )}
                    </React.Fragment>
                  );
                })}
            </VersionChoiceContainer>
          </>
        )}
        {generationMode === GENERATION_MODES.EXCEL && (
          <>
            <FixInputContainer>
              <InputContainer>
                <InputComponent
                  name={'excel_choice'}
                  type={'select'}
                  label={'Choix du Registre'}
                  options={getRegistriesOptions()}
                  onChange={handleTargetRegistry}
                  clearable={true.toString()}
                  value={getRegistriesOptions().filter(value => value.value === targetGeneration?.registryId)}
                  sharable={false}
                />
              </InputContainer>
              <InputContainer>
                <InputComponent
                  key={'entity_choice'}
                  name={'entity_choice'}
                  type={'select'}
                  label={"Choix de l'entreprise"}
                  options={getEntitiesOptions()}
                  onChange={handleTargetEntity}
                  sharable={false}
                />
              </InputContainer>
              <InputContainer>
                <InputComponent
                  key={'lang_choice'}
                  name={'lang_choice'}
                  type={'select'}
                  label={'Choix de la langue'}
                  options={getLangOptions()}
                  onChange={handleTargetLang}
                  sharable={false}
                  value={{ value: 'FR', label: 'Français' }}
                />
              </InputContainer>
            </FixInputContainer>
            <VersionChoiceContainer>
              {targetGeneration?.name &&
                getSurveysByRegistryId(targetGeneration?.registryId, targetGeneration?.name)?.map((link, index) => {
                  return (
                    <VersionItem key={index}>
                      <InputComponent
                        key={link.survey.name + index}
                        name={link.survey.id}
                        type={'select'}
                        label={link.survey.name}
                        options={link.versions.map(version => ({
                          label: version.replaceAll('_', ' '),
                          value: version,
                        }))}
                        onChange={handleTargetGeneration}
                        value={targetGeneration[link.survey.id] || ''}
                        sharable={false}
                      />
                    </VersionItem>
                  );
                })}
            </VersionChoiceContainer>
          </>
        )}
        {generationMode === GENERATION_MODES.ALL && (
          <EntitiesContainer>
            {selectedAccount.entities.map((entity, index) => (
              <EntityContainer key={index}>
                <EntityTitle>{entity.name}</EntityTitle>
                <DocumentsList>
                  {selectedAccount?.actionRights.documents.map((doc, index) => (
                    <label key={index + doc.id + entity.name} htmlFor={`docID-${entity.name + doc.id}`}>
                      <input
                        checked={isCheckedZipContent(doc, entity)}
                        type='checkbox'
                        name={`doc-${doc.id}`}
                        id={`docID-${entity.name + doc.id}`}
                        onChange={e => toggleZipContent(doc, entity, e.target.checked, 'docx')}
                      />
                      {doc.label}
                    </label>
                  ))}
                  {selectedAccount?.actionRights.registries.map((registry, index) => (
                    <label key={index + registry.id + entity.name} htmlFor={`registryId-${entity.name + registry.id}`}>
                      <input
                        checked={isCheckedZipContent(registry, entity)}
                        type='checkbox'
                        name={`registry-${registry.id}`}
                        id={`registryId-${entity.name + registry.id}`}
                        onChange={e => toggleZipContent(registry, entity, e.target.checked, 'excel')}
                      />
                      {registry.label}
                    </label>
                  ))}
                </DocumentsList>
              </EntityContainer>
            ))}
          </EntitiesContainer>
        )}
        <ActionContainer>
          {(generationMode === GENERATION_MODES.WORD || generationMode === GENERATION_MODES.EXCEL) && (
            <Button
              disabled={!isGenerationReady()}
              onClick={generationMode === GENERATION_MODES.WORD ? handleDocxSubmit : handleExcelSubmit}
              label={'Générer le document'}
            />
          )}
          {/*{generationMode === GENERATION_MODES.ALL && <Button onClick={getCustomZip} label={'Générer le ZIP'} />}*/}
        </ActionContainer>
      </Content>
    </DashboardGenerationContainer>
  );
};

const EntityContainer = styled.div``;

const EntitiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin-top: 20px;
`;

const EntityTitle = styled.div``;

const DocumentsList = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
`;

const Tab = styled.div<{ current: boolean }>`
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;

  ${({ current }) =>
    current &&
    `
    border-bottom: 1px solid #187ead;
  `};
`;

const DashboardGenerationContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const InputContainer = styled.div``;

const VersionChoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  row-gap: 20px;
  column-gap: 20px;
  //flex: 2;
  overflow-y: auto;
  //grid-template-columns: 1fr 1fr;
  margin-top: 20px;
  padding: 20px 20px 60px 20px;

  > * {
    //width: 50%;
  }

  ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #c7c7c7;
  }

  ::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: inset 2.1px -1px 12px 0px #f0f0f0;
  }
`;

const FixInputContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  margin-top: 15px;

  column-gap: 15px;

  > * {
    flex: 1;
  }
`;

const VersionItem = styled.div``;

const ActionContainer = styled.div`
  display: flex;
  column-gap: 15px;
  justify-content: flex-end;
  padding: 0 100px;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
  align-items: center;
  min-height: 70px;
`;
